import econetLogo from '../assets/econet_ai.png'
import africomLogo from '../assets/africom.png'
import umbaiLogo from '../assets/umbai.png'
import pointsAfricaLogo from '../assets/points_africa.png'
import cgratesLogo from '../assets/cgrates.png'
import opensipsLogo from '../assets/opensips.png'
import redpandaLogo from '../assets/redpanda.png'
import clickhouseLogo from '../assets/clickhouse.png'
import open5gsLogo from '../assets/open5gs.png'
import codemagicLogo from '../assets/platforms/codemagic.svg'
import shorebirdLogo from '../assets/platforms/shorebird.png'
import strapiLogo from '../assets/platforms/strapi.svg'

export const profile = {
  name: 'Paradzai Gwira',
  role: 'AI Software Engineer',
  location: 'Harare, Zimbabwe',
  email: 'paradzaigwira@gmail.com',
  phone: '+263 71 533 6984',
  resume: '/resume.pdf',
  cvPage: '/cv',
  github: 'https://github.com/PRedemption',
  linkedin: 'https://www.linkedin.com/in/paradzai-gwira-216169194/',
  whatsapp: 'https://wa.me/263715336984'
}

export const rotatingRoles = [
  'AI-powered automation',
  'conversational agents',
  'real-time data pipelines',
  'distributed backends',
  'telecom-grade platforms'
]

export const stats = [
  { value: 5, suffix: '+', label: 'Years shipping production software' },
  { value: 5, suffix: '+', label: 'Domains: AI, telecom, fintech, loyalty, data' },
  { value: 4, suffix: '', label: 'Platforms: Android, iOS, Huawei, Web (PWA)' },
  { value: 9, suffix: '+', label: 'Apps live in public app stores' }
]

// Apps I've shipped to public stores (Google Play, App Store, Huawei AppGallery, Web).
export const storeApps = ['Taura', 'Points Africa', 'Kurira', 'Mobilielink', 'CatchApp', 'Maswerasei', 'Homekonnect', 'Umbai Merchant', 'Hello Africa']

export const capabilities = [
  {
    icon: 'fa-brain',
    title: 'Applied AI & automation',
    text: 'LLM-backed assistants, chatbots and WhatsApp automation that take on real customer and operational work, grounded in verified data.',
    tags: ['LLMs', 'Python', 'Chatbots', 'RAG-style grounding'],
    featured: true
  },
  {
    icon: 'fa-diagram-project',
    title: 'Distributed backends',
    text: 'Secure, scalable services and REST APIs with Java, Spring Boot, Python and Node.js.',
    tags: ['Spring Boot', 'Microservices', 'REST']
  },
  {
    icon: 'fa-wave-square',
    title: 'Real-time data',
    text: 'Data warehouses fed by CDC over a Redpanda message bus into ClickHouse, for revenue assurance and reporting.',
    tags: ['ClickHouse', 'Redpanda', 'Debezium CDC']
  },
  {
    icon: 'fa-tower-broadcast',
    title: 'Telecom & VoIP',
    text: 'Call routing and processing with OpenSIPS, real-time billing with CGRateS, 5G core networks with Open5GS, and integrations with multiple mobile network operators.',
    tags: ['OpenSIPS', 'CGRateS', 'Open5GS', 'SIP']
  },
  {
    icon: 'fa-mobile-screen',
    title: 'Mobile products',
    text: '9+ apps shipped to public stores across Android, iOS, Huawei and Web (PWA), from VoIP calling to loyalty and payments.',
    tags: ['Flutter', 'Android', 'iOS', 'Huawei', 'PWA']
  },
  {
    icon: 'fa-server',
    title: 'DevOps & infrastructure',
    text: 'Linux, containers and CI/CD pipelines that keep production observable and boring.',
    tags: ['Docker', 'Kubernetes', 'CI/CD', 'Linux']
  }
]

export const platformGroups = [
  { id: 'enterprise', label: 'Enterprise solutions' },
  { id: 'telecom', label: 'Telecom & data platforms' },
  { id: 'mobile', label: 'Mobile delivery platforms' },
  { id: 'web', label: 'Web technologies' }
]

export const platforms = [
  {
    group: 'enterprise',
    name: 'Frappe',
    icon: 'fas fa-layer-group',
    role: 'Enterprise application framework',
    text: 'The Python framework behind custom enterprise systems: DocTypes, workflows, role permissions, server scripts and one REST API across every module.',
    tags: ['Python', 'DocTypes', 'Workflows', 'REST']
  },
  {
    group: 'enterprise',
    name: 'ERPNext',
    icon: 'fas fa-cubes',
    role: 'Enterprise resource planning',
    text: 'One operational system for the whole business: Accounting, Buying, Selling, Stock, Assets, CRM, Projects, Support, Manufacturing, Quality, HR, Payroll, Point of Sale, Loan Management, Maintenance and Website.',
    tags: ['Accounting', 'Stock', 'HR', 'Payroll']
  },
  {
    group: 'enterprise',
    name: 'Banking & finance',
    icon: 'fas fa-building-columns',
    role: 'Finance operations',
    text: 'Procurement, accounts payable, accounts receivable, fixed assets, inventory, intercompany accounting and expense allocations, shaped around how a finance team closes the books.',
    tags: ['Payables', 'Receivables', 'Intercompany']
  },
  {
    group: 'enterprise',
    name: 'Systems integration',
    icon: 'fas fa-plug',
    role: 'Core banking and reporting',
    text: 'REST, SOAP and GraphQL middleware that keeps ERPNext, core banking platforms and regulatory reporting on the same audit trail.',
    tags: ['REST', 'SOAP', 'GraphQL']
  },
  {
    group: 'enterprise',
    name: 'Secure delivery',
    icon: 'fas fa-shield-halved',
    role: 'Banking-grade SDLC',
    text: 'Code review, UAT and controls aligned to OWASP, ISO 27001 and PCI-DSS, so finance systems stay available and safe to change.',
    tags: ['OWASP', 'ISO 27001', 'PCI-DSS']
  },
  {
    group: 'enterprise',
    name: 'Finance data',
    icon: 'fas fa-database',
    role: 'Models, SQL and reports',
    text: 'Relational models, stored procedures and finance reports on MariaDB, PostgreSQL, Oracle and SQL Server.',
    tags: ['MariaDB', 'Oracle', 'SQL Server']
  },
  {
    group: 'telecom',
    name: 'CGRateS',
    logo: cgratesLogo,
    role: 'Real-time billing',
    text: 'Rating, charging and billing for voice and data: tariff plans, account balances and CDR rating in real time.',
    tags: ['Rating', 'Charging', 'CDRs']
  },
  {
    group: 'telecom',
    name: 'OpenSIPS',
    logo: opensipsLogo,
    role: 'Call routing & processing',
    text: 'SIP proxy logic for routing and processing calls: dispatching, load balancing and call control.',
    tags: ['SIP', 'Routing', 'Call control']
  },
  {
    group: 'telecom',
    name: 'Open5GS',
    logo: open5gsLogo,
    role: '5G networks · 6G research',
    text: 'Building 5G standalone core networks with open-source Open5GS, exploring emerging 6G features, and growing a community around open telecom.',
    tags: ['5G SA core', '6G research', 'Community']
  },
  {
    group: 'telecom',
    name: 'Redpanda',
    logo: redpandaLogo,
    role: 'Message bus',
    text: 'Kafka-compatible streaming backbone carrying CDC events and CDRs between services as they happen.',
    tags: ['Streaming', 'Kafka API', 'Events']
  },
  {
    group: 'telecom',
    name: 'ClickHouse',
    logo: clickhouseLogo,
    role: 'Warehouse with CDC',
    text: 'Columnar data warehouse fed by Debezium change-data-capture, powering revenue assurance and analytics.',
    tags: ['Debezium CDC', 'OLAP', 'Warehousing']
  },
  {
    group: 'telecom',
    name: 'Grafana',
    icon: 'devicon-grafana-plain colored',
    role: 'Dashboards & monitoring',
    text: 'Dashboards and alerting over ClickHouse and service metrics, from revenue assurance views to operational monitoring.',
    tags: ['Dashboards', 'Alerting', 'Observability']
  },
  {
    group: 'mobile',
    name: 'Firebase',
    icon: 'devicon-firebase-plain colored',
    role: 'App backend & insights',
    text: 'Managing app features end to end: Crashlytics, Analytics, Remote Config, Cloud Messaging and more.',
    tags: ['Crashlytics', 'Analytics', 'Remote Config']
  },
  {
    group: 'mobile',
    name: 'Codemagic',
    markImg: codemagicLogo,
    role: 'CI/CD for mobile',
    text: 'Automating builds, signing, testing and store releases for Android and iOS.',
    tags: ['CI/CD', 'Code signing', 'Store releases']
  },
  {
    group: 'mobile',
    name: 'Shorebird',
    markImg: shorebirdLogo,
    role: 'Over-the-air updates',
    text: 'Shipping Flutter fixes and features over the air, without waiting on app store review.',
    tags: ['OTA updates', 'Code push', 'Flutter']
  },
  {
    group: 'mobile',
    name: 'Strapi',
    markImg: strapiLogo,
    role: 'Headless CMS',
    text: 'Managing dynamic in-app content through a headless CMS, so content changes need no new release.',
    tags: ['Headless CMS', 'Dynamic content', 'REST / GraphQL']
  },
  {
    group: 'web',
    name: 'React',
    icon: 'devicon-react-original colored',
    role: 'Web interfaces',
    text: 'Component-based web applications, including this portfolio, with HTML, CSS and JavaScript.',
    tags: ['HTML5', 'CSS3', 'JavaScript']
  },
  {
    group: 'web',
    name: 'Vue.js',
    icon: 'devicon-vuejs-plain colored',
    role: 'Progressive web UI',
    text: 'Vue interfaces for business web apps, wired to REST APIs.',
    tags: ['Vue', 'SPA', 'REST']
  },
  {
    group: 'web',
    name: 'Angular',
    icon: 'devicon-angularjs-plain colored',
    role: 'Enterprise web apps',
    text: 'Angular front ends for operational web apps and long-running business workflows.',
    tags: ['Angular', 'TypeScript', 'SPA']
  },
  {
    group: 'web',
    name: 'Node.js',
    icon: 'devicon-nodejs-plain colored',
    role: 'Web services',
    text: 'Node.js and Express services behind web and mobile clients, including REST, SOAP and GraphQL.',
    tags: ['Express', 'REST', 'GraphQL']
  },
  {
    group: 'web',
    name: 'TypeScript',
    icon: 'devicon-typescript-plain colored',
    role: 'Typed web stack',
    text: 'Typed JavaScript for web front ends and services, with PWAs delivered alongside native apps.',
    tags: ['TypeScript', 'PWA', 'JavaScript']
  }
]

export const experience = [
  {
    id: 'econet',
    company: 'Econet AI',
    logo: econetLogo,
    role: 'Artificial Intelligence Software Engineer',
    period: 'Jul 2026 — Present',
    location: 'Harare · On-site',
    current: true,
    summary: 'Leading the design of enterprise AI: generative AI, LLM, RAG and agent capabilities wired into telecom and business services.',
    highlights: [
      'Architect enterprise AI solutions integrating generative AI, LLMs, RAG and AI agents',
      'Build scalable AI and data pipelines over large operational datasets',
      'Ship Java / Spring Boot and Python microservices that connect models to core systems',
      'Evaluate and productionise models for performance, reliability and cost',
      'Set AI engineering practice: evaluation, prompt engineering, monitoring and responsible AI',
      'Deliver Frappe ERPNext for banking and finance, including the core modules and integrations for procurement, payables, receivables, fixed assets, inventory, intercompany accounting and expense allocations'
    ],
    tags: ['Generative AI', 'LLMs', 'RAG', 'AI agents', 'Spring Boot', 'Python', 'Frappe', 'ERPNext']
  },
  {
    id: 'africom',
    company: 'Africom Holdings',
    logo: africomLogo,
    role: 'Senior Software, VoIP & Data Engineer · Tech Lead',
    period: 'Oct 2021 — Jun 2026',
    location: 'Harare · Hybrid',
    summary: 'Led cross-platform VoIP products, then grew into data engineering and DevOps across the platform.',
    highlights: [
      'Led VoIP applications for Android, iOS and Huawei devices',
      'Worked on call routing and processing with OpenSIPS and real-time billing with CGRateS',
      'Built data warehouses with CDC over a Redpanda message bus into ClickHouse',
      'Designed revenue assurance dashboards that helped control leakage through core-network changes',
      'Delivered backends for VoIP, messaging and payment apps serving thousands of users',
      'Deployed LTE 4G EPC infrastructure; ran Linux, databases and CI/CD; mentored junior engineers',
      'Built Frappe ERPNext for banking-sector finance: Accounting, Buying, Selling, Stock, Assets, CRM, Projects, Support, Manufacturing, Quality, HR, Payroll, Point of Sale, Loan Management, Maintenance and Website',
      'Delivered procurement, accounts payable, accounts receivable, fixed assets, inventory, intercompany accounting and expense allocations, with SQL on MariaDB, PostgreSQL, Oracle and SQL Server'
    ],
    tags: ['VoIP', 'OpenSIPS', 'CGRateS', 'ClickHouse', 'Redpanda', 'DevOps', 'Frappe', 'ERPNext']
  },
  {
    id: 'points-africa',
    company: 'Points Africa',
    logo: pointsAfricaLogo,
    role: 'Full Stack Developer · Loyalty Platform',
    period: 'Part time',
    location: 'Greater Accra · Remote',
    summary: 'Building a loyalty system across PWA, Android and iOS, backed by secure, cloud-based APIs.',
    highlights: [
      'Develop and maintain cross-platform mobile applications (PWA, Android and iOS) and backend systems using Flutter (Dart), Node.js and Express',
      'Design, develop and maintain secure, scalable RESTful APIs and cloud-based backend services',
      'Collaborate with product, design and engineering teams to analyse requirements and deliver high-quality software',
      'Optimise performance, scalability, reliability and user experience across multiple platforms',
      'Perform code reviews, troubleshoot issues, implement best practices and take part in pair programming',
      'Participate in Agile development, testing and CI/CD pipelines across the full SDLC',
      'Prepare technical documentation, support implementation and contribute to continuous product improvement'
    ],
    tags: ['Loyalty system', 'Flutter', 'Node.js', 'Express', 'REST APIs', 'CI/CD']
  },
  {
    id: 'umbai',
    company: 'Umbai',
    logo: umbaiLogo,
    role: 'Full Stack Developer',
    period: 'Jun 2023 — May 2025',
    location: 'Western Cape · Remote',
    summary: 'Built payment platforms, chatbots, REST APIs and mobile products for African markets.',
    highlights: [
      'Integrated 6 payment gateways and the services of 6 mobile network operators',
      'Built WhatsApp chatbots and business automations for service, sales and orders',
      'Developed .NET MAUI, C#, Vue.js and Angular apps on MVC microservices and REST APIs',
      'Administered Linux servers and databases; configured site-to-site VPNs and DevOps workflows',
      'Developed Frappe ERPNext web apps for banking and finance on Vue.js and Angular, covering the core modules plus procurement, payables, receivables, fixed assets, inventory, intercompany accounting and expense allocations'
    ],
    tags: ['Payments', 'Chatbots', 'C#', 'Flutter', 'REST APIs', 'Frappe', 'ERPNext']
  }
]

export const projects = [
  {
    kicker: 'Data · Revenue assurance',
    title: 'Real-time revenue assurance platform',
    text: 'CDC pipelines streaming billing and usage events into an analytical warehouse, so leakage shows up in dashboards before it hits the P&L.',
    stack: ['Debezium', 'Redpanda', 'ClickHouse', 'Grafana'],
    flow: ['source DB', 'CDC', 'stream', 'warehouse', 'insight'],
    wide: true
  },
  {
    kicker: 'AI · Automation',
    title: 'Conversational assistants',
    text: 'Chatbots and WhatsApp automation that resolve customer journeys end to end, including the one answering questions on this page.',
    stack: ['LLMs', 'Python', 'Node.js'],
    links: [{ label: 'Try it', href: '#ask' }]
  },
  {
    kicker: 'Telecom · Voice',
    title: 'Cross-platform VoIP suite',
    text: 'SIP-based calling apps and backend services for Android, iOS and Huawei devices.',
    stack: ['OpenSIPS', 'CGRateS', 'Flutter', 'Java']
  },
  {
    kicker: 'VoIP · Mobile calling',
    title: 'Taura',
    text: 'A VoIP calling app for low-cost international calls to any mobile number or landline worldwide. The person you call needs no internet or app.',
    stack: ['VoIP / SIP', 'Flutter', 'Android', 'iOS'],
    links: [
      { label: 'Play Store', href: 'https://play.google.com/store/apps/details?id=org.duri.taura' },
      { label: 'App Store', href: 'https://apps.apple.com/zw/app/taura/id1592996258' }
    ]
  },
  {
    kicker: 'Mobile · Product',
    title: 'Kurira',
    text: 'A cross-platform app built for everyday voice and connectivity in African markets.',
    stack: ['Flutter', 'Node.js'],
    links: [
      { label: 'Play Store', href: 'https://play.google.com/store/apps/details?id=org.kurira.app' },
      { label: 'App Store', href: 'https://apps.apple.com/ng/app/kurira/id1643459023' }
    ]
  },
  {
    kicker: 'Fintech · Payments',
    title: 'Umbai Merchant',
    text: 'A merchant app for payments and transaction management, backed by secure REST APIs.',
    stack: ['Flutter', 'C#', 'REST'],
    links: [{ label: 'Play Store', href: 'https://play.google.com/store/apps/details?id=com.umbai.app' }]
  }
]

export const stack = [
  { name: 'Python', icon: 'devicon-python-plain colored' },
  { name: 'Java', icon: 'devicon-java-plain colored' },
  { name: 'Spring', icon: 'devicon-spring-original colored' },
  { name: 'TypeScript', icon: 'devicon-typescript-plain colored' },
  { name: 'Node.js', icon: 'devicon-nodejs-plain colored' },
  { name: 'Flutter', icon: 'devicon-flutter-plain colored' },
  { name: 'Dart', icon: 'devicon-dart-plain colored' },
  { name: 'React', icon: 'devicon-react-original colored' },
  { name: 'C#', icon: 'devicon-csharp-plain colored' },
  { name: 'Go', icon: 'devicon-go-original-wordmark colored' },
  { name: 'OpenSIPS', icon: 'fas fa-phone-volume stack-fa' },
  { name: 'CGRateS', icon: 'fas fa-file-invoice-dollar stack-fa' },
  { name: 'Open5GS', icon: 'fas fa-signal stack-fa' },
  { name: 'Redpanda', icon: 'fas fa-bars-staggered stack-fa' },
  { name: 'ClickHouse', icon: 'fas fa-database stack-fa' },
  { name: 'Codemagic', icon: 'fas fa-wand-magic-sparkles stack-fa' },
  { name: 'Shorebird', icon: 'fas fa-dove stack-fa' },
  { name: 'Strapi', icon: 'fas fa-layer-group stack-fa' },
  { name: 'Docker', icon: 'devicon-docker-plain colored' },
  { name: 'Kubernetes', icon: 'devicon-kubernetes-plain colored' },
  { name: 'Linux', icon: 'devicon-linux-plain' },
  { name: 'ERPNext', icon: 'fas fa-cubes stack-fa' },
  { name: 'Frappe', icon: 'fas fa-layer-group stack-fa' },
  { name: 'PostgreSQL', icon: 'devicon-postgresql-plain colored' },
  { name: 'MariaDB', icon: 'devicon-mysql-plain colored' },
  { name: 'Oracle', icon: 'devicon-oracle-original colored' },
  { name: 'MySQL', icon: 'devicon-mysql-plain colored' },
  { name: 'MongoDB', icon: 'devicon-mongodb-plain colored' },
  { name: 'Grafana', icon: 'devicon-grafana-plain colored' },
  { name: 'Firebase', icon: 'devicon-firebase-plain colored' },
  { name: 'Google Cloud', icon: 'devicon-googlecloud-plain colored' },
  { name: 'Git', icon: 'devicon-git-plain colored' },
  { name: 'Jenkins', icon: 'devicon-jenkins-plain colored' },
  { name: 'Redis', icon: 'devicon-redis-plain colored' }
]

// The Lab: how I work, and what's on the bench right now.
export const labLoop = [
  { id: 'learn', icon: 'fa-book-open', title: 'Learn', text: 'University foundations, self-taught mastery: specs, RFCs, source code and docs. New stacks in weeks, not quarters.' },
  { id: 'explore', icon: 'fa-flask', title: 'Explore', text: 'Small, measured experiments in a lab setting before anything touches production.' },
  { id: 'build', icon: 'fa-screwdriver-wrench', title: 'Build', text: 'Turn the winning experiment into clean, tested, observable systems.' },
  { id: 'deliver', icon: 'fa-rocket', title: 'Deliver', text: 'Ship, monitor and feed what I learned back into the next loop.' }
]

export const labStatuses = {
  building: { label: 'Building', icon: 'fa-hammer' },
  researching: { label: 'Researching', icon: 'fa-microscope' },
  shipped: { label: 'Shipped', icon: 'fa-circle-check' },
  oss: { label: 'Open source', icon: 'fa-code-branch' },
  live: { label: 'Live here', icon: 'fa-signal' },
  learning: { label: 'Learning', icon: 'fa-graduation-cap' }
}

export const experiments = [
  { code: 'EXP-01', status: 'building', title: 'Agentic AI & RAG for telecom', text: 'LLM, retrieval and agent workflows grounded in enterprise data, with evaluation and guardrails built in.', stack: ['LLMs', 'RAG', 'AI agents', 'Python', 'Spring Boot'] },
  { code: 'EXP-02', status: 'researching', title: '5G core lab → 6G exploration', text: 'Building 5G standalone networks on Open5GS, exploring the features shaping 6G, and building a community of open-telecom builders.', stack: ['Open5GS', '5G SA', '6G', 'Community'] },
  { code: 'EXP-03', status: 'shipped', title: 'Real-time CDC data warehouse', text: 'Change-data-capture from operational databases, streamed over Redpanda into ClickHouse for revenue assurance.', stack: ['Debezium', 'Redpanda', 'ClickHouse', 'Grafana'] },
  { code: 'EXP-04', status: 'oss', title: 'flutter_dtmf_pro', text: 'Open-source Flutter plugin that generates DTMF telephony tones on Android, iOS and Web.', stack: ['Dart', 'Flutter', 'VoIP'], href: 'https://github.com/PRedemption/flutter_dtmf_pro' },
  { code: 'EXP-05', status: 'live', title: 'Grounded portfolio assistant', text: 'An LLM assistant that answers only from verified facts and hands off to a human when unsure.', stack: ['LLM', 'Gemini', 'React'], href: '#ask' },
  { code: 'EXP-06', status: 'learning', title: 'Java SE 21 certification', text: 'Deepening modern Java (records, virtual threads, pattern matching) toward Oracle certification.', stack: ['Java 21', 'Spring', 'JVM'] }
]

// Sponsorship & mentorship. Set `githubSponsors` to your https://github.com/sponsors/... URL once enrolled.
export const sponsorship = {
  githubSponsors: null,
  pillars: [
    { icon: 'fa-code-branch', title: 'Open-source foundations', text: 'Maintain, test and document projects like flutter_dtmf_pro so others can build on them with confidence.' },
    { icon: 'fa-tower-cell', title: '5G → 6G community lab', text: 'Cloud credits and lab hardware for hands-on 5G experiments, published as open guides for the community.' },
    { icon: 'fa-user-graduate', title: 'Mentorship cohorts', text: 'Structured mentoring, code reviews and career guidance for young engineers who are hungry to learn.' },
    { icon: 'fa-people-group', title: 'Community events', text: 'Hackathons, study groups and meetups where learners ship real projects together.' }
  ],
  tiers: [
    { id: 'supporter', name: 'Supporter', cadence: 'One-off or monthly', perks: ['Name on the sponsors wall', 'Project and lab updates', 'The warm feeling of building the ecosystem'], cta: 'Become a supporter' },
    { id: 'lab', name: 'Lab Sponsor', cadence: 'Monthly', featured: true, perks: ['Logo on this site and project READMEs', 'Quarterly lab reports on what you funded', 'A voice on the open-source roadmap'], cta: 'Sponsor the lab' },
    { id: 'mentorship', name: 'Mentorship Partner', cadence: 'Custom', perks: ['Fund a full mentee cohort', 'Co-host sessions and workshops', 'Meet emerging engineering talent early'], cta: 'Partner on mentorship' }
  ]
}

export const sections = [
  { id: 'home', label: 'Home' },
  { id: 'capabilities', label: 'Capabilities' },
  { id: 'experience', label: 'Experience' },
  { id: 'lab', label: 'Lab' },
  { id: 'work', label: 'Work' },
  { id: 'github', label: 'GitHub' },
  { id: 'sponsor', label: 'Sponsor', nav: false },
  { id: 'ask', label: 'Ask AI' },
  { id: 'contact', label: 'Contact' }
]
